import "./MatchableRates.scss";
import { MdOutlineSafetyDivider } from "react-icons/md";
import { InfoTooltip } from "../../Components";

interface MatchableRatesProps {
  residentialResponseRates?: {
    residentialDeliveryRate: string;
    residentialResponseRate: string;
  };
}

const MatchableRates: React.FC<MatchableRatesProps> = ({ residentialResponseRates }) => {
  return (
    <div className="matchableRatesContainer">
      <MdOutlineSafetyDivider />
      <div className="title">Matchable Rates:</div>
      <div className="value">Delivery: {residentialResponseRates?.residentialDeliveryRate}</div>
      <div className="value">Response: {residentialResponseRates?.residentialResponseRate}</div>
      <InfoTooltip size="sm">
        Delivery: The percentage of total impressions that were delivered to matchable impressions.{" "}
        <br />
        <br />
        Response: The percentage of total responses that originated from matchable impressions.
      </InfoTooltip>
    </div>
  );
};

export default MatchableRates;
